export const getSessionTtl = (isKeepMeLoggedInEnabled, overrideLoginSessionTtl, isKeepMeLoggedInChecked) => {
    // Disabled or unchecked
    if (!isKeepMeLoggedInEnabled || !isKeepMeLoggedInChecked) {
        return 0;
    }
    // Enabled, checked and no override value provided
    if (!overrideLoginSessionTtl) {
        return undefined;
    }
    // Enabled, checked and override value provided
    const parsed = parseInt(overrideLoginSessionTtl, 10);
    return Number.isNaN(parsed) ? undefined : parsed;
};
//# sourceMappingURL=getSessionTtl.js.map